import MiniColumn from "./MiniColumn";

export default MiniColumn